import "./PlansList.css";
import * as React from 'react';
import { SubscriptionInfo, BillingPlan, ChargebeeInstance } from '../common';
import { EnterprisePlanCard, RegularPlanCard } from '../PlanCard';
import { PaymentType, ProductType, Subscription } from '../../../../store/Tenant';
import { SwitchTrialDialog } from "../SwitchTrialDialog";
import Checkout from "../Checkout";
import ContactUsDialog from "../ContactUsDialog";

type Props = {
    plans: BillingPlan[];
    subscription: SubscriptionInfo;
    chargebee: ChargebeeInstance | undefined;
    canManage: boolean;
    onSwitchTrialConfirmed: (planId: string) => void;
    onSuccessfulCheckout: () => void;
}

export const PlansList = (props: Props) => {
    const { subscription, chargebee, canManage, plans } = props;
    const badgeProps = {
        isExpired: Subscription.isExpired(subscription),
        isTrial: subscription.isTrial
    };

    const [showContactUsDialogPlan, setShowContactUsDialogPlan] = React.useState<BillingPlan>();
    const [checkoutPlan, setCheckoutPlan] = React.useState<BillingPlan>();
    const [switchTrialToPlan, setSwitchTrialToPlan] = React.useState<BillingPlan>();
    
    return <div className='plans-list'>
        {
            plans.map(_ => <div key={_.id} className="plan-card-wrapper">
                {
                    _.paymentType === PaymentType.Direct
                        ? <EnterprisePlanCard
                            plan={_}
                            badgeProps={badgeProps}
                            isCurrent={_.id == subscription.planId}
                            onShowContactUsDialog={setShowContactUsDialogPlan}
                        />
                        : <RegularPlanCard
                            plan={_}
                            badgeProps={badgeProps}
                            isCurrent={_.id === subscription.planId}
                            disabled={!canManage || !chargebee || Subscription.isDirect(subscription)}
                            onChange={setCheckoutPlan}
                            onBuy={setCheckoutPlan}
                            onSwitchTrial={setSwitchTrialToPlan}
                            hideManageSubscriptionButton={subscription.productType === ProductType.Once}
                        />
                }
            </div>)
        }
        {
            switchTrialToPlan && <SwitchTrialDialog
                plan={switchTrialToPlan}
                subscription={subscription}
                onDismiss={() => setSwitchTrialToPlan(undefined)}
                onConfirm={() => props.onSwitchTrialConfirmed(switchTrialToPlan.id)}
            />
        }
        {
            !!checkoutPlan && <Checkout
                chargebee={chargebee}
                plan={checkoutPlan}
                subscription={subscription}
                onDismiss={() => setCheckoutPlan(undefined)}
                onSuccessful={props.onSuccessfulCheckout}
            />
        }
        {
            !!showContactUsDialogPlan && <ContactUsDialog
                planName={showContactUsDialogPlan.name}
                onDismiss={() => setShowContactUsDialogPlan(undefined)}
            />
        }
    </div>
}